import { CssBaseline, ThemeProvider } from "@mui/material";
import { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import EditAbout from "./scenes/aboutUs/Edit.jsx";
import About from "./scenes/aboutUs/index.jsx";

import ChangeEmail from "./scenes/auth/changeEmail/index.jsx";
import Changepw from "./scenes/auth/changepw/index.jsx";
import Signup from "./scenes/auth/signup/Signup.jsx";

import BookingDetails from "./scenes/bookings/ViewBookingById.jsx";
import BookingsTable from "./scenes/bookings/index.jsx";

import Dashboard from "./scenes/dashboard";

import Sidebar from "./scenes/global/Sidebar";
import Topbar from "./scenes/global/Topbar";

import Home from "./scenes/home/index.jsx";

import Payment from "./scenes/payment/index.jsx";

import RenterGetById from "./scenes/renter/RenterGetById.jsx";
import Renter from "./scenes/renter/index.jsx";

import SellerGetById from "./scenes/seller/SellerGetById.jsx";
import Seller from "./scenes/seller/index.jsx";

import SocialEdit from "./scenes/socialMedia/Edit.jsx";
import Social from "./scenes/socialMedia/index.jsx";

import PrivateRoutes from "./scenes/utils/PrivateRoutes.jsx";

import { ColorModeContext, useMode } from "./theme";

import Vehicle from "./scenes/vehicle/index.jsx";
import VehicleGetById from "./scenes/vehicle/ViewById.jsx";

import UserStripe from "./scenes/userstripe/UserStripe.jsx";

import ContactCustomer from "./scenes/contact/ContactCustomer.jsx";

import Blogs from "./scenes/blogs/index.jsx";
import AddBlog from "./scenes/blogs/AddBlogs.jsx";
import EditBlog from "./scenes/blogs/EditBlogs.jsx";
import ViewBlog from "./scenes/blogs/View.jsx";

import Projects from "./scenes/projects/projects/index.jsx";
import AddProject from "./scenes/projects/addProject/index.jsx";
import EditProject from "./scenes/projects/projects/Edit.jsx";
import ViewProject from "./scenes/projects/projects/ViewProject.jsx";


function App() {
  const [theme, colorMode] = useMode();

  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  const location = useLocation();

  const isLoginPage = location.pathname === "/";


  useEffect(() => {
    setMobileNavOpen(false);
  }, [location.pathname]);


  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />

        <div className="app">

          {!isLoginPage && (
            <Sidebar
              mobileOpen={mobileNavOpen}
              onMobileClose={() => setMobileNavOpen(false)}
            />
          )}

          <main className="content">

            {!isLoginPage && (
              <Topbar
                onMenuClick={() => setMobileNavOpen(true)}
              />
            )}

            <Routes>

              {/* LOGIN */}
              <Route
                path="/"
                element={<Signup />}
              />


              {/* PRIVATE ROUTES */}
              <Route element={<PrivateRoutes />}>


                {/* DASHBOARD */}
                <Route
                  path="/dd"
                  element={<Dashboard />}
                />


                {/* SELLERS */}
                <Route
                  path="/seller"
                  element={<Seller />}
                />

                <Route
                  path="/seller/:id"
                  element={<SellerGetById />}
                />


                {/* RENTERS */}
                <Route
                  path="/renter"
                  element={<Renter />}
                />

                <Route
                  path="/renter/:id"
                  element={<RenterGetById />}
                />


                {/* PAYMENTS */}
                <Route
                  path="/payment"
                  element={<Payment />}
                />


                {/* BOOKINGS */}
                <Route
                  path="/bookings"
                  element={<BookingsTable />}
                />

                <Route
                  path="/bookings/:id"
                  element={<BookingDetails />}
                />


                {/* AUTH SETTINGS */}
                <Route
                  path="/changepw"
                  element={<Changepw />}
                />

                <Route
                  path="/changeemail"
                  element={<ChangeEmail />}
                />


                {/* SOCIAL MEDIA */}
                <Route
                  path="/social"
                  element={<Social />}
                />

                <Route
                  path="/social/editLinks"
                  element={<SocialEdit />}
                />


                {/* ABOUT */}
                <Route
                  path="/about"
                  element={<About />}
                />

                <Route
                  path="/about-us/edit"
                  element={<EditAbout />}
                />


                {/* HOME */}
                <Route
                  path="/home"
                  element={<Home />}
                />


                {/* VEHICLES */}
                <Route
                  path="/vehicle"
                  element={<Vehicle />}
                />

                <Route
                  path="/vehicle/:id"
                  element={<VehicleGetById />}
                />


                {/* USER STRIPE */}
                <Route
                  path="/userstripe"
                  element={<UserStripe />}
                />


                {/* CONTACT */}
                <Route
                  path="/contact"
                  element={<ContactCustomer />}
                />


                {/* BLOGS */}
                <Route
                  path="/blog"
                  element={<Blogs />}
                />

                <Route
                  path="/blog/add"
                  element={<AddBlog />}
                />

                <Route
                  path="/blog/edit/:id"
                  element={<EditBlog />}
                />

                <Route
                  path="/blog/view/:id"
                  element={<ViewBlog />}
                />


                {/* PROJECTS */}
                <Route
                  path="/project"
                  element={<Projects />}
                />

                <Route
                  path="/project/addproject"
                  element={<AddProject />}
                />

                <Route
                  path="/project/editproject/:id"
                  element={<EditProject />}
                />

                <Route
                  path="/project/viewproject/:id"
                  element={<ViewProject />}
                />


              </Route>

            </Routes>

          </main>

        </div>

      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}


export default App;
